import React from 'react';

interface Props {
  children: any;
}

const Page = ({ children }: Props) => {
  return (
    <div className="p-5">
      <div className="bg-white w-full rounded-xl p-5 shadow">{children}</div>
    </div>
  );
};

export default Page;
